import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const contentful = defineConnector({
  identifier: "contentful",
  name: "Contentful",
  tagLine: "Headless CMS",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: () => "https://.*\\.contentful\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Contentful API key",
      items: [
        {
          kind: "markdown",
          content:
            "Go to your [Contentful space settings](https://app.contentful.com/) and navigate to **Settings > API keys** to create or copy your Content Management API token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Content Management API Token",
          placeholder: "CFPAT-...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.contentful.com/spaces",
  },
});
